var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.41012 0.685986C10.0386 0.0575241 11.0575 0.0575227 11.686 0.685985C12.3144 1.31445 12.3144 2.33339 11.686 2.96185L8.39336 6.25447L11.6606 9.52172C12.2583 10.1194 12.2583 11.0884 11.6606 11.6861C11.0629 12.2837 10.0939 12.2837 9.49626 11.6861L6.22901 8.41882L2.96185 11.686C2.33339 12.3144 1.31445 12.3144 0.685985 11.686C0.0575229 11.0575 0.057523 10.0386 0.685985 9.41012L3.95315 6.14296L0.660609 2.85042C0.0629396 2.25275 0.0629393 1.28374 0.660609 0.686071C1.25828 0.0884012 2.22729 0.0884021 2.82496 0.686072L6.1175 3.97861L9.41012 0.685986Z",
    fill: "#FA9418"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.1d8ebaf4d3d8084cd96c0cc3556a4dcc.svg";
export { ForwardRef as ReactComponent };